/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Cenorion Tenant Edge API (DEV)
 * Live API Gateway routes, documented from backend contracts/rest.
 * OpenAPI spec version: live
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ProblemDetails,
  TenantWhitelist,
  TenantWhitelistCreateRequest,
  TenantWhitelistDefaultRequest,
  TenantWhitelistUpdateRequest,
  TenantWhitelistsResponse
} from '../../models';

import { apiMutator } from '../../../http/mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Every list the tenant holds — `id`, `name`, `is_default`, `version`, `app_count`, `number_count`, `created_at`, `updated_at` — without entries.
 * @summary List the tenant's whitelists
 */
export const listTenantWhitelists = (

 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<TenantWhitelistsResponse>(
      {url: `/v1/tenants/me/whitelists`, method: 'GET', signal
    },
      options);
    }




export const getListTenantWhitelistsQueryKey = () => {
    return [
    `/v1/tenants/me/whitelists`
    ] as const;
    }


export const getListTenantWhitelistsQueryOptions = <TData = Awaited<ReturnType<typeof listTenantWhitelists>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenantWhitelists>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTenantWhitelistsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTenantWhitelists>>> = ({ signal }) => listTenantWhitelists(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTenantWhitelists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTenantWhitelistsQueryResult = NonNullable<Awaited<ReturnType<typeof listTenantWhitelists>>>
export type ListTenantWhitelistsQueryError = ProblemDetails


export function useListTenantWhitelists<TData = Awaited<ReturnType<typeof listTenantWhitelists>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenantWhitelists>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTenantWhitelists>>,
          TError,
          Awaited<ReturnType<typeof listTenantWhitelists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTenantWhitelists<TData = Awaited<ReturnType<typeof listTenantWhitelists>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenantWhitelists>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTenantWhitelists>>,
          TError,
          Awaited<ReturnType<typeof listTenantWhitelists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTenantWhitelists<TData = Awaited<ReturnType<typeof listTenantWhitelists>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenantWhitelists>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the tenant's whitelists
 */

export function useListTenantWhitelists<TData = Awaited<ReturnType<typeof listTenantWhitelists>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTenantWhitelists>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTenantWhitelistsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Creates a list with a generated `id` and `version: 1`.
 * @summary Create a whitelist
 */
export const createTenantWhitelist = (
    tenantWhitelistCreateRequest: TenantWhitelistCreateRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<TenantWhitelist>(
      {url: `/v1/tenants/me/whitelists`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tenantWhitelistCreateRequest, signal
    },
      options);
    }




export const getCreateTenantWhitelistMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTenantWhitelist>>, TError,{data: TenantWhitelistCreateRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof createTenantWhitelist>>, TError,{data: TenantWhitelistCreateRequest}, TContext> => {

const mutationKey = ['createTenantWhitelist'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTenantWhitelist>>, {data: TenantWhitelistCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  createTenantWhitelist(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTenantWhitelistMutationResult = NonNullable<Awaited<ReturnType<typeof createTenantWhitelist>>>
    export type CreateTenantWhitelistMutationBody = TenantWhitelistCreateRequest
    export type CreateTenantWhitelistMutationError = ProblemDetails

    /**
 * @summary Create a whitelist
 */
export const useCreateTenantWhitelist = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTenantWhitelist>>, TError,{data: TenantWhitelistCreateRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTenantWhitelist>>,
        TError,
        {data: TenantWhitelistCreateRequest},
        TContext
      > => {
      return useMutation(getCreateTenantWhitelistMutationOptions(options), queryClient);
    }
    /**
 * The list with its entries, and when it was created (`created_at`, never changes) and last changed (`updated_at`).
 * @summary Read one whitelist with its entries
 */
export const getTenantWhitelist = (
    whitelistId: string,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<TenantWhitelist>(
      {url: `/v1/tenants/me/whitelists/${whitelistId}`, method: 'GET', signal
    },
      options);
    }




export const getGetTenantWhitelistQueryKey = (whitelistId: string,) => {
    return [
    `/v1/tenants/me/whitelists/${whitelistId}`
    ] as const;
    }


export const getGetTenantWhitelistQueryOptions = <TData = Awaited<ReturnType<typeof getTenantWhitelist>>, TError = ProblemDetails>(whitelistId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantWhitelist>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTenantWhitelistQueryKey(whitelistId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTenantWhitelist>>> = ({ signal }) => getTenantWhitelist(whitelistId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: whitelistId !== null && whitelistId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTenantWhitelist>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTenantWhitelistQueryResult = NonNullable<Awaited<ReturnType<typeof getTenantWhitelist>>>
export type GetTenantWhitelistQueryError = ProblemDetails


export function useGetTenantWhitelist<TData = Awaited<ReturnType<typeof getTenantWhitelist>>, TError = ProblemDetails>(
 whitelistId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantWhitelist>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantWhitelist>>,
          TError,
          Awaited<ReturnType<typeof getTenantWhitelist>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantWhitelist<TData = Awaited<ReturnType<typeof getTenantWhitelist>>, TError = ProblemDetails>(
 whitelistId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantWhitelist>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantWhitelist>>,
          TError,
          Awaited<ReturnType<typeof getTenantWhitelist>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantWhitelist<TData = Awaited<ReturnType<typeof getTenantWhitelist>>, TError = ProblemDetails>(
 whitelistId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantWhitelist>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read one whitelist with its entries
 */

export function useGetTenantWhitelist<TData = Awaited<ReturnType<typeof getTenantWhitelist>>, TError = ProblemDetails>(
 whitelistId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantWhitelist>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTenantWhitelistQueryOptions(whitelistId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * **A patch.** An absent property is left alone; `apps` and `numbers` each replace the whole set when present.
 * @summary Change a whitelist
 */
export const patchTenantWhitelist = (
    whitelistId: string,
    tenantWhitelistUpdateRequest: TenantWhitelistUpdateRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<TenantWhitelist>(
      {url: `/v1/tenants/me/whitelists/${whitelistId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: tenantWhitelistUpdateRequest, signal
    },
      options);
    }




export const getPatchTenantWhitelistMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTenantWhitelist>>, TError,{whitelistId: string;data: TenantWhitelistUpdateRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof patchTenantWhitelist>>, TError,{whitelistId: string;data: TenantWhitelistUpdateRequest}, TContext> => {

const mutationKey = ['patchTenantWhitelist'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchTenantWhitelist>>, {whitelistId: string;data: TenantWhitelistUpdateRequest}> = (props) => {
          const {whitelistId,data} = props ?? {};

          return  patchTenantWhitelist(whitelistId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchTenantWhitelistMutationResult = NonNullable<Awaited<ReturnType<typeof patchTenantWhitelist>>>
    export type PatchTenantWhitelistMutationBody = TenantWhitelistUpdateRequest
    export type PatchTenantWhitelistMutationError = ProblemDetails

    /**
 * @summary Change a whitelist
 */
export const usePatchTenantWhitelist = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTenantWhitelist>>, TError,{whitelistId: string;data: TenantWhitelistUpdateRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchTenantWhitelist>>,
        TError,
        {whitelistId: string;data: TenantWhitelistUpdateRequest},
        TContext
      > => {
      return useMutation(getPatchTenantWhitelistMutationOptions(options), queryClient);
    }
    /**
 * The default is the list whose numbers devices receive in the app configuration; its apps do not reach them there.
 * @summary Make a whitelist the tenant's default
 */
export const makeDefaultTenantWhitelist = (
    whitelistId: string,
    tenantWhitelistDefaultRequest: TenantWhitelistDefaultRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<TenantWhitelist>(
      {url: `/v1/tenants/me/whitelists/${whitelistId}/default`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tenantWhitelistDefaultRequest, signal
    },
      options);
    }




export const getMakeDefaultTenantWhitelistMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof makeDefaultTenantWhitelist>>, TError,{whitelistId: string;data: TenantWhitelistDefaultRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof makeDefaultTenantWhitelist>>, TError,{whitelistId: string;data: TenantWhitelistDefaultRequest}, TContext> => {

const mutationKey = ['makeDefaultTenantWhitelist'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof makeDefaultTenantWhitelist>>, {whitelistId: string;data: TenantWhitelistDefaultRequest}> = (props) => {
          const {whitelistId,data} = props ?? {};

          return  makeDefaultTenantWhitelist(whitelistId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MakeDefaultTenantWhitelistMutationResult = NonNullable<Awaited<ReturnType<typeof makeDefaultTenantWhitelist>>>
    export type MakeDefaultTenantWhitelistMutationBody = TenantWhitelistDefaultRequest
    export type MakeDefaultTenantWhitelistMutationError = ProblemDetails

    /**
 * @summary Make a whitelist the tenant's default
 */
export const useMakeDefaultTenantWhitelist = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof makeDefaultTenantWhitelist>>, TError,{whitelistId: string;data: TenantWhitelistDefaultRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof makeDefaultTenantWhitelist>>,
        TError,
        {whitelistId: string;data: TenantWhitelistDefaultRequest},
        TContext
      > => {
      return useMutation(getMakeDefaultTenantWhitelistMutationOptions(options), queryClient);
    }
